import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error handler for JavaScript errors
window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global JavaScript Error:', {
    message,
    source,
    lineno,
    colno,
    error: error?.stack
  });

  // In production, you could send this to an error reporting service
  if (process.env.NODE_ENV === 'production') {
    // Example: sendErrorToService({ message, source, lineno, colno, error });
  }

  // Return false to prevent the default browser error handler
  return false;
};

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled Promise Rejection:', {
    reason: event.reason,
    promise: event.promise
  });

  // Prevent the default browser behavior (which logs to console)
  event.preventDefault();

  // In production, you could send this to an error reporting service
  if (process.env.NODE_ENV === 'production') {
    // Example: sendErrorToService({ type: 'unhandledRejection', reason: event.reason });
  }
});

// Global handler for uncaught errors in event handlers
window.addEventListener('error', function(event) {
  console.error('Global Error Event:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });

  // In production, you could send this to an error reporting service
  if (process.env.NODE_ENV === 'production') {
    // Example: sendErrorToService({ type: 'errorEvent', ...event });
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
